import { render, staticRenderFns } from "./WhatsAppIntegration.vue?vue&type=template&id=105b2a60&scoped=true"
import script from "./WhatsAppIntegration.vue?vue&type=script&lang=js"
export * from "./WhatsAppIntegration.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppIntegration.vue?vue&type=style&index=0&id=105b2a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105b2a60",
  null
  
)

export default component.exports